import { render, staticRenderFns } from "./chartOTPDocument.vue?vue&type=template&id=5fdcc19d&scoped=true&"
import script from "./chartOTPDocument.vue?vue&type=script&lang=js&"
export * from "./chartOTPDocument.vue?vue&type=script&lang=js&"
import style0 from "./chartOTPDocument.vue?vue&type=style&index=0&id=5fdcc19d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdcc19d",
  null
  
)

export default component.exports
import {QCard,QCardSection,QBar,QBtnDropdown,QInput,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QBar,QBtnDropdown,QInput,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
